(function () {
  var isDragging = false;
  
  function pauseAllVideos(slider) {
    var allCards = slider.querySelectorAll('.vc-Card');
    
    allCards.forEach(function(card) {
      // Pause video-section elements using their pause() method
      var videoSections = card.querySelectorAll('video-section');
      videoSections.forEach(function(vs) {
        try {
          if (typeof vs.pause === 'function') {
            vs.pause();
          }
          var video = vs.querySelector('video');
          if (video) {
            video.pause();
          }
        } catch (e) {}
      });
      
      // Pause any native video elements
      var videos = card.querySelectorAll('video');
      videos.forEach(function(video) {
        try {
          video.pause();
        } catch (e) {}
      });
      
      // Handle YouTube iframes - just pause
      var iframes = card.querySelectorAll('iframe');
      iframes.forEach(function(iframe) {
        try {
          if (iframe.src && iframe.src.includes('youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        } catch (e) {}
      });
    });
  }

  if (typeof document === 'undefined') return;

  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('.vc-Slider');
    
    sliders.forEach(function(slider) {
      // Check for Flickity and add listener
      function initFlickityListener() {
        if (window.Flickity && Flickity.data) {
          var flkty = Flickity.data(slider);
          if (flkty) {
            // Track drag state
            flkty.on('dragStart', function() {
              isDragging = true;
              pauseAllVideos(slider);
            });
            
            flkty.on('dragEnd', function() {
              // Keep isDragging true for a short time to prevent click from triggering
              setTimeout(function() {
                isDragging = false;
              }, 100);
            });
            
            // Pause when slide changes
            flkty.on('change', function() {
              pauseAllVideos(slider);
            });
            
            // Prevent staticClick from playing video during/after drag
            flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
              // staticClick only fires when there's no drag, so this is a real click
              // Don't prevent - let the click work normally
            });
            
            return true;
          }
        }
        return false;
      }
      
      // Try immediately, then retry after a delay
      if (!initFlickityListener()) {
        setTimeout(function() {
          initFlickityListener();
        }, 500);
      }
      
      // Prevent deferred-media from loading during drag
      slider.addEventListener('click', function(e) {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        
        // Pause when clicking on navigation dots
        if (e.target.closest('.flickity-page-dots') || e.target.closest('.flickity-button')) {
          pauseAllVideos(slider);
        }
      }, true);
    });
  });
})();

